import { Routes } from "@angular/router";
import { AuthComponent } from "../components/layouts/auth/auth.component";
import { LoginComponent } from "../components/pages/login/login.component";
import { ForgotPasswordComponent } from "../components/pages/forgot-password/forgot-password.component";
import { EMPTY_ROUTE } from "@shared/common/routes.common";
import { SetPasswordComponent } from "../components/pages/set-password/set-password.component";
import { keycloakGuard } from "@ogs/ngx-keycloak";


// eslint-disable-next-line @tseslint/typedef
export const AUTHENTICATE_PARAM_MAPS = {
  SET_PASSWORD_REGISTER_KEY: "registerKey"
};
/* eslint-disable-next-line @tseslint/typedef */
export const AUTHENTICATE_ROUTES = {
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot-password",
  SET_PASSWORD: `set-password/:${ AUTHENTICATE_PARAM_MAPS.SET_PASSWORD_REGISTER_KEY }`,
  PASSWORD_EXPIRED: "password-expired"
};
export const AUTHENTICATE_ROUTES_DEFINITION: Routes = [
  {
    path: EMPTY_ROUTE,
    component: AuthComponent,
    children: [
      {
        path: EMPTY_ROUTE,
        redirectTo: "login",
        pathMatch: "full"
      },
      {
        path: AUTHENTICATE_ROUTES.LOGIN,
        component: LoginComponent,
        canActivate: [ keycloakGuard({ reverse: true }) ]
      },
      {
        path: AUTHENTICATE_ROUTES.FORGOT_PASSWORD,
        component: ForgotPasswordComponent
      },
      {
        path: AUTHENTICATE_ROUTES.SET_PASSWORD,
        component: SetPasswordComponent
      },
      {
        path: AUTHENTICATE_ROUTES.PASSWORD_EXPIRED,
        // eslint-disable-next-line @tseslint/typedef
        loadComponent: async () => await import("@features/authenticate/components/pages/password-expired/password-expired.component").then((m) => m.PasswordExpiredComponent),
        canActivate: [ keycloakGuard({ reverse: true }) ]
      }
    ]
  }
];
